module.exports = __webpack_public_path__ + "img/thegif.2aee5b16.gif";